export default '/pricing/subscription-mobile';
